import { Card } from "@coherence-design-system/controls";
import { IStackTokens, mergeStyles, Stack } from "@fluentui/react";
import { Button } from "@fluentui/react-components";
import React from "react";
import { useNavigate } from "react-router";
import { getHeader } from "../../Styles/Page.styles";

interface HomeNavProps {}

const onboardText = "Onboard Assets";
const serversText = "Manage Assets";
const jobsText = "Manage Jobs";
const adminText = "Service Administration";

const stackTokens: IStackTokens = {
    childrenGap: 20 + " " + 20, // vertical gap + ' ' + horizontal gap,
};

const centerStyles = mergeStyles({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
});

const cardSize = mergeStyles({
    width: "300px",
    maxWidth: "100%",
    height: "180px",
    boxSizing: "border-box",
    "@media screen and (max-width: 400px)": {
        width: "100%",
    },
});

const HomeNav: React.FunctionComponent<HomeNavProps> = () => {
    const navigate = useNavigate();
    return (
        <div id="homeNav">
            <Stack wrap horizontal horizontalAlign="space-evenly" tokens={stackTokens}>
                <Stack.Item>
                    <div className={cardSize}>
                        <Card header={getHeader(onboardText, "center")}>
                            <p>Onboard your devices to ensure they are compliant.</p>
                            <div className={centerStyles}>
                                <Button
                                    appearance="primary"
                                    onClick={() => navigate("/onboarding")}
                                >
                                    {onboardText}
                                </Button>
                            </div>
                        </Card>
                    </div>
                </Stack.Item>
                <Stack.Item>
                    <div className={cardSize}>
                        <Card header={getHeader(serversText, "center")}>
                            <p>Manage your devices and view patching data.</p>
                            <div className={centerStyles}>
                                <Button
                                    appearance="primary"
                                    onClick={() => navigate("/manageservers")}
                                >
                                    {serversText}
                                </Button>
                            </div>
                        </Card>
                    </div>
                </Stack.Item>
                <Stack.Item>
                    <div className={cardSize}>
                        <Card header={getHeader(jobsText, "center")}>
                            <p>Create new patching jobs and edit current jobs.</p>
                            <div className={centerStyles}>
                                <Button
                                    appearance="primary"
                                    onClick={() => navigate("/managejobs")}
                                >
                                    {jobsText}
                                </Button>
                            </div>
                        </Card>
                    </div>
                </Stack.Item>
                <Stack.Item>
                    <div className={cardSize}>
                        <Card header={getHeader(adminText, "center")}>
                            <p>Assign IcM team, set email contact, delegate users.</p>
                            <div className={centerStyles}>
                                <Button
                                    appearance="primary"
                                    onClick={() => navigate("/serviceadministration")}
                                >
                                    {adminText}
                                </Button>
                            </div>
                        </Card>
                    </div>
                </Stack.Item>
            </Stack>
        </div>
    );
};

export default HomeNav;
